// src/components/dashboard/QuickActions.jsx
import React from "react";

const QuickActions = React.memo(({ onSendMoney, onRequestMoney, onEscrowPay, onAddProduct }) => {
  const actions = [
     {
      label: "Add Item",
      icon: "bi-box",
      color: "text-blue-600",
      bg: "bg-blue-50",
      onClick: onAddProduct,
    },
    // {
    //   label: "Send Money",
    //   icon: "bi-send-fill",
    //   color: "text-blue-600",
    //   bg: "bg-blue-50",
    //   onClick: onSendMoney,
    // },
    // {
    //   label: "Request Money",
    //   icon: "bi-cash-coin",
    //   color: "text-green-600",
    //   bg: "bg-green-50",
    //   onClick: onRequestMoney,
    // },
    // {
    //   label: "Escrow Pay",
    //   icon: "bi-receipt",
    //   color: "text-yellow-600",
    //   bg: "bg-yellow-50",
    //   onClick: onEscrowPay,
    // },
  ];

  const handleActionClick = (action) => {
    action.onClick();
  };

  return (
    <div className="w-full px-2 ">
      <div className="grid grid-cols-2 items-center sm:grid-cols-4 gap-3 p-3 rounded-2xl border border-gray-200">
        {actions.map((action, idx) => (
          <button
            key={idx}
            onClick={() => handleActionClick(action)}
            className="flex flex-col items-center justify-center p-3 rounded-xl bg-white border border-gray-200 transition-all active:scale-95 hover:shadow-sm min-h-[80px]"
          >
            <div
              className={`w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-lg mb-2 ${action.bg}`}
            >
              <i className={`bi ${action.icon} ${action.color} text-base sm:text-lg`} />
            </div>
            <span className="text-xs font-medium  text-center leading-tight">
              {action.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
});

QuickActions.displayName = 'QuickActions';

export default QuickActions;